module.exports = __webpack_public_path__ + "files/26683960f9aa43be82e8d1a1b3e69b7d.png";